module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"document-filter\" class=\"document active\">\r\n    <div class=\"document-heading expanded-page\" data-toggle=\"collapse\" data-target=\"#well_filter\">\r\n        <h4 class=\"document-title document-type-show\">\r\n            <a role=\"button\">\r\n                Search & Filter\r\n            </a>\r\n        </h4>\r\n        <a role=\"button\" data-toggle=\"collapse\" data-target=\"#well_filter\" class=\"switch\">\r\n            <i class=\"fa pf-carot-down\" aria-expanded=\"true\"></i>\r\n        </a>\r\n    </div>\r\n    <div id=\"well_filter\" class=\"document-body collapse in\" style=\"box-shadow: none; padding-top: 10px;\">\r\n        <div class=\"document-items\" style=\"padding-right:20px;\">\r\n            <div class=\"search-filter\">\r\n                <div class=\"search-forms\" style=\"margin-bottom:3px;\" >\r\n                    <input id=\"searchLeftPanel\" title=\"Enter an object type or name to filter\" type=\"text\" placeholder=\"")
    ; __append(escapeFn( isForm ? 'Search App Design' : 'Search Report Design' ))
    ; __append("\" class=\"search-box search-query\" />\r\n                </div>\r\n                <div class=\"filter-forms\">\r\n                    <select id=\"filtermenu\" aria-labelledby=\"filtermenu\">\r\n                        <option class=\"select-filter\" value=\"none\">None</option>\r\n                        ")
    ;  filterList.map(function(filterItem) { 
    ; __append("\r\n                            <option class=\"select-filter\" value=\"")
    ; __append(escapeFn(filterItem.id))
    ; __append("\" data-id=\"")
    ; __append(escapeFn(filterItem.id))
    ; __append("\" data-type-id=\"")
    ; __append(escapeFn(filterItem.type))
    ; __append("\">\r\n                                 ")
    ; __append(escapeFn(filterItem.name))
    ; __append("\r\n                            </option>\r\n                        ")
    ;  }); 
    ; __append("\r\n                    </select>\r\n                </div>\r\n                <div id=\"filterResults\" class=\"hide\" style=\"max-height: 150px; color: #000000; overflow: auto; background: white; margin-top: 5px; border-radius: 4px;\">\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}